<template>
  <div>
    <v-form ref="form">
      <v-dialog
        :overlay="false"
        fullscreen
        value="true"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-app-bar flat class="card-toolbar-title">
            <v-toolbar-title>
              <span class="headline">{{ editItem.userGroupId ? 'Edit' : 'Create' }} User Group</span>
            </v-toolbar-title>
            <v-spacer />
            <v-btn icon @click.native="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-app-bar>
          <v-card-text>
            <v-container grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    id="userGroupName"
                    v-model="editItem.userGroupName"
                    :rules="required"
                    name="userGroupName"
                    class="required"
                    label="User Group Name"
                  />
                  <v-select
                    id="client"
                    v-model="selectedClients"
                    :items="clientDetails"
                    :rules="requiredArray"
                    item-text="clientNameDesc"
                    item-value="id"
                    name="client"
                    menu-props="auto"
                    label="Client(s)"
                    class="required"
                    hide-selected
                    multiple
                    chips
                    deletable-chips
                  /><!-- menu-props="auto" is a work around for vuetify Bug #10750 -->
                </v-flex>
                <v-flex xs12 md6>
                  <v-textarea
                    id="userGroupDesc"
                    v-model="editItem.userGroupDesc"
                    name="userGroupDesc"
                    label="User Group Description"
                    textarea
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-layout v-if="selectedClients.length > 0" row wrap>
            <v-flex xs12 md3>
              <v-card class="selected-clients">
                <v-card-title primary-title>
                  <h3>Selected Clients</h3>
                </v-card-title>
                <v-list>
                  <template v-for="(value, key) in editItem.clientDefs">
                    <v-list-item
                      :key="key"
                      :class="[ activeClient == key ? 'active' : '' ]"
                      ripple
                      @click="activateClient(key)"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="clientIndex[key].clientNameDesc" />
                        <v-list-item-subtitle v-text="clientIndex[key].clientName" />
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="'v' + key" />
                  </template>
                </v-list>
              </v-card>
            </v-flex>
            <v-flex xs12 md9>
              <v-card v-if="editItem.clientDefs[activeClient]" class="group-selection">
                <v-card-title primary-title>
                  <h3>{{ clientIndex[activeClient].clientNameDesc }}</h3>
                </v-card-title>
                <v-card-actions>
                  <div class="mx-auto">
                    <v-btn v-if="!editItem.clientDefs[activeClient].isSelectAllGroups && !groupSummary" color="primray" @click.native="summary()">View Summary</v-btn>
                  </div>
                </v-card-actions>
                <v-card-text>
                  <div v-if="!groupSummary">
                    <v-switch
                      v-model="editItem.clientDefs[activeClient].isSelectAllGroups"
                      label="Include All Groups"
                    />
                    <div v-if="!editItem.clientDefs[activeClient].isSelectAllGroups">
                      <v-autocomplete
                        id="tgcSelect"
                        :loading="isTrackingGroupsLoading"
                        :items="trackingGroupsAll"
                        :filter="customFilter"
                        label="Include/Exclude Tracking Groups/Client IDs"
                        :search-input.sync="searchTrackingGroups"
                      >
                        <template v-slot:item="data">
                          <v-list-item-action @click.stop="">
                            <div class="autocomplete-buttons">
                              <v-btn outlined
                                     fab
                                     small
                                     color="indigo"
                                     @click.stop="addTrackGroup(data.item, 'I')"
                              >
                                <v-icon>add</v-icon>
                              </v-btn>
                              <v-btn outlined
                                     fab
                                     small
                                     color="red"
                                     @click.stop="addTrackGroup(data.item, 'E')"
                              >
                                <v-icon>remove</v-icon>
                              </v-btn>
                            </div>
                          </v-list-item-action>
                          <v-list-item-content @click.stop="">
                            <div v-if="data.item !== 'All'">
                              <v-list-item-title><GroupTrackClient :type="data.item.type" /> {{ data.item.name }}</v-list-item-title>
                              <v-list-item-subtitle>{{ data.item.id }}</v-list-item-subtitle>
                            </div>
                            <div v-else>
                              <v-list-item-title>Include/Exclude All the above listed Groups</v-list-item-title>
                            </div>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete
                        id="bgSelect"
                        :loading="isBenefitsGroupLoading"
                        :items="benefitGroupsAll"
                        :filter="customFilter"
                        label="Include/Exclude Benefit Groups"
                        :search-input.sync="searchBenefitGroups"
                      >
                        <template v-slot:item="data">
                          <v-list-item-action @click.stop="">
                            <div class="autocomplete-buttons">
                              <v-btn outlined
                                     fab
                                     small
                                     color="indigo"
                                     @click.stop="addBenefitGroup(data.item, 'I')"
                              >
                                <v-icon>add</v-icon>
                              </v-btn>
                              <v-btn outlined
                                     fab
                                     small
                                     color="red"
                                     @click.stop="addBenefitGroup(data.item, 'E')"
                              >
                                <v-icon>remove</v-icon>
                              </v-btn>
                            </div>
                          </v-list-item-action>
                          <v-list-item-content @click.stop="">
                            <div v-if="data.item !== 'All'">
                              <v-list-item-title><GroupTrackClient :type="data.item.type" /> {{ data.item.name }}</v-list-item-title>
                              <v-list-item-subtitle>{{ data.item.id }}</v-list-item-subtitle>
                            </div>
                            <div v-else>
                              <v-list-item-title>Include/Exclude All the above listed Groups</v-list-item-title>
                            </div>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete
                        id="tgcSelect"
                        :loading="isParentGroupsLoading"
                        :items="parentGroupsAll"
                        :filter="customFilter"
                        label="Include/Exclude Parent Groups"
                        :search-input.sync="searchParentGroups"
                      >
                        <template v-slot:item="data">
                          <v-list-item-action @click.stop="">
                            <div class="autocomplete-buttons">
                              <v-btn outlined
                                     fab
                                     small
                                     color="indigo"
                                     @click.stop="addParentGroup(data.item, 'I', searchParentGroups)"
                              >
                                <v-icon>add</v-icon>
                              </v-btn>
                              <v-btn outlined
                                     fab
                                     small
                                     color="red"
                                     @click.stop="addParentGroup(data.item, 'E', searchParentGroups)"
                              >
                                <v-icon>remove</v-icon>
                              </v-btn>
                            </div>
                          </v-list-item-action>
                          <v-list-item-content @click.stop="">
                            <div v-if="data.item !== 'All'">
                              <v-list-item-title><GroupTrackClient :type="data.item.type" :value2="searchParentGroups" /> {{ data.item.name }}</v-list-item-title>
                              <v-list-item-subtitle>{{ data.item.id }}</v-list-item-subtitle>
                            </div>
                            <div v-else>
                              <v-list-item-title>Include/Exclude All the above listed Groups</v-list-item-title>
                            </div>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </div>
                    <manage-user-groups-modal-table :defs="editItem.clientDefs[activeClient]" @delete="$delete(editItem.clientDefs[activeClient].Active, editItem.clientDefs[activeClient].Active.indexOf($event))" />
                  </div>
                  <manage-user-groups-view-summary v-else :group-summary="groupSummary" @close="setGroupSummary(false)" />
                </v-card-text>
                <v-card-actions>
                  <div class="mx-auto">
                    <v-btn v-if="!editItem.clientDefs[activeClient].isSelectAllGroups && !groupSummary" color="primray" @click.native="summary()">View Summary</v-btn>
                  </div>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn color="primary" text @click.native="close">Cancel</v-btn>
              <v-btn color="primary" @click.native="save">Save User Group</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import ManageUserGroupsModalTable from './ManageUserGroupsModalTable'
import ManageUserGroupsViewSummary from './ManageUserGroupsViewSummary'
import GroupTrackClient from './GroupTrackClient'
import cloneDeep from 'lodash/cloneDeep'
import some from 'lodash/some'
import reject from 'lodash/reject'
import find from 'lodash/find'
const GROUP_SEARCH_LENGTH = 4

export default {
  name: 'manager-user-groups-modal',
  components: {
    ManageUserGroupsModalTable,
    ManageUserGroupsViewSummary,
    GroupTrackClient
  },
  props: {
    userGroupDetails: Object,
    clientIndex: Object,
    clientDetails: Array
  },
  data() {
    return {
      editItem: {},
      selectedClients: [],
      searchBenefitGroups: null,
      searchTrackingGroups: null,
      searchParentGroups: null,
      activeClient: null,
      isTrackingGroupsLoading: false,
      isBenefitsGroupLoading: false,
      isParentGroupsLoading: false,
      required: [
        v => !!v || 'Required'
      ],
      requiredArray: [
        v => !!v.length || 'Required'
      ],
      customFilter() {
        return true //don't actually filter anything, just set up the control as if it were autocomplete with filtering
      }
    }
  },
  computed: {
    ...mapState('manageUserGroups', ['trackingGroups', 'benefitGroups', 'parentGroups', 'groupSummary']),
    benefitGroupsAll() {
      return this.benefitGroups.length ? this.benefitGroups.concat(['All']) : this.benefitGroups
    },
    trackingGroupsAll() {
      return this.trackingGroups.length ? this.trackingGroups.concat(['All']) : this.trackingGroups
    },
    parentGroupsAll() {
      return this.parentGroups.length ? this.parentGroups.concat(['All']) : this.parentGroups
    }
  },
  watch: {
    selectedClients() {
      this.selectedClients.forEach(v => { if (!this.editItem.clientDefs[v]) this.$set(this.editItem.clientDefs, v, { isSelectAllGroups: false, Active: [], Inactive: [] }) })
      Object.keys(this.editItem.clientDefs).forEach(v => { if (this.selectedClients.indexOf(parseInt(v)) === -1) this.$delete(this.editItem.clientDefs, v) })
    },
    searchTrackingGroups(value) {
      if (value && value.length >= GROUP_SEARCH_LENGTH) {
        this.isTrackingGroupsLoading = true
        this.getTrackingGroups({ search: value, clientName: this.clientIndex[this.activeClient].clientName }).then(() => this.isTrackingGroupsLoading = false)
      }
    },
    searchBenefitGroups(value) {
      if (value && value.length >= GROUP_SEARCH_LENGTH) {
        this.isBenefitsGroupLoading = true
        this.getBenefitGroups({ search: value, clientName: this.clientIndex[this.activeClient].clientName }).then(() => this.isBenefitsGroupLoading = false)
      }
    },
    searchParentGroups(value) {
      if (value && value.length >= GROUP_SEARCH_LENGTH) {
        this.isParentGroupsLoading = true
        this.getParentGroups({ search: value, clientName: this.clientIndex[this.activeClient].clientName }).then(() => this.isParentGroupsLoading = false)
      }
    }
  },
  created() {
    this.editItem = cloneDeep(this.userGroupDetails)
    this.$set(this.editItem, 'clientDefs', {})
    this.editItem.groupDefList.forEach(el => {
      if (!this.editItem.clientDefs[el.clientNameId]) this.$set(this.editItem.clientDefs, el.clientNameId, { Active: [], Inactive: [] })
      this.editItem.clientDefs[el.clientNameId][el.recordInactiveFlag === 'A' ? 'Active' : 'Inactive'].push(el)
    })
    this.selectedClients = Object.keys(this.editItem.clientDefs).map(Number)
    this.selectedClients.forEach(v => this.$set(this.editItem.clientDefs[v], 'isSelectAllGroups', some(this.editItem.clientDefs[v].Active, { userGroupTypeCode: 'ALL_TRACKING_GROUPS' })))
  },
  methods: {
    ...mapActions('manageUserGroups', ['getTrackingGroups', 'getBenefitGroups', 'getParentGroups', 'viewGroupSummary', 'saveUserGroup']),
    ...mapMutations('manageUserGroups', ['setGroupSummary', 'setTrackingGroups', 'setParentGroups', 'setBenefitGroups']),
    save() {
      const saveData = { userGroupId: this.editItem.userGroupId, userGroupName: this.editItem.userGroupName, userGroupDesc: this.editItem.userGroupDesc, groupDefList: [] }
      //Filter out ALL_TRACKING_GROUPS if not on, use existing ALL_TRACKING_GROUPS if it exists, if not then create it
      this.selectedClients.forEach(v => saveData.groupDefList.push(...(
        this.editItem.clientDefs[v].isSelectAllGroups
          ? [find(this.editItem.clientDefs[v].Active, { userGroupTypeCode: 'ALL_TRACKING_GROUPS' }) || {
            userGroupTypeCode: 'ALL_TRACKING_GROUPS', actionTypeCode: 'I', clientNameId: parseInt(v)
          }] : reject(this.editItem.clientDefs[v].Active, { userGroupTypeCode: 'ALL_TRACKING_GROUPS' })
      )))
      this.saveUserGroup(saveData).then(this.close, () => {})
    },
    close() {
      this.setGroupSummary(false)
      this.$emit('close')
    },
    activateClient(key) {
      this.activeClient = key
      this.setGroupSummary(false)
      this.setTrackingGroups([])
      this.setBenefitGroups([])
      this.setParentGroups([])
    },
    addTrackGroup(group, action) {
      if (group === 'All') {
        this.trackingGroups.forEach(v => this.addGroup(v, action))
      } else {
        this.addGroup(group, action)
      }
    },
    addBenefitGroup(group, action) {
      if (group === 'All') {
        this.benefitGroups.forEach(v => this.addGroup(v, action))
      } else {
        this.addGroup(group, action)
      }
    },
    addParentGroup(group, action, search) {
      if (group === 'All') {
        this.parentGroups.forEach(v => this.addGroup(v, action, search))
      } else {
        this.addGroup(group, action, search)
      }
    },
    addGroup(group, action, value2) {
      const newGroup = {
        userGroupTypeCode: group.type,
        userGroupTypeValue: group.id,
        userGroupTypeValue2: value2,
        actionTypeCode: action,
        clientNameId: parseInt(this.activeClient)
      }
      if (!some(this.editItem.clientDefs[this.activeClient].Active, newGroup)) this.editItem.clientDefs[this.activeClient].Active.push(newGroup)
    },
    summary() {
      this.editItem.groupDefList = reject(this.editItem.clientDefs[this.activeClient].Active, { userGroupTypeCode: 'ALL_TRACKING_GROUPS' })
      this.viewGroupSummary({ data: this.editItem, clientName: this.clientIndex[this.activeClient].clientName })
    }
  }
}
</script>

<style lang="scss" scoped>
  .active {
    background-color: $color-primary-light !important;
  }
  .selected-clients.v-card .v-card__title {
    background-color: $color-primary !important;
    color: $white;
  }
  .group-selection.v-card .v-card__title {
    background-color: $color-primary-dark !important;
    color: $white;
  }
  .card-title {
    background-color: $black-3;
    color: $color-primary;
  }
  .card-toolbar-title {
    background-color: $color-secondary;
  }
  .autocomplete-buttons{
    white-space: nowrap;
  }
  .v-list-item__content{
    padding-left: 20px;
  }
</style>
